export class Community {
    communityId: number;
    communityName: string;
    communityNumber: string;
    communityNumberConverted: number;
    companyId: number;
}
